const en = {
  'cancelSubscription.title': 'Are you sure you want to cancel your subscription?',
  'cancelSubscription.description': 'By doing this, you will loose your special price with the promotional code applied.',
  'cancelSubscription.understandButton': 'I understand. Continue to Cancel my subscription',
  'cancelSubscription.description.apple': 'To complete the process, you must cancel the subscription on your device, you can follow the instructions below: https://support.apple.com/en-us/HT204939.',
};

export default en;
